import { render, staticRenderFns } from "./ClassAssignmentsPage.vue?vue&type=template&id=05cfc171&scoped=true"
import script from "./ClassAssignmentsPage.vue?vue&type=script&lang=js"
export * from "./ClassAssignmentsPage.vue?vue&type=script&lang=js"
import style0 from "./ClassAssignmentsPage.vue?vue&type=style&index=0&id=05cfc171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cfc171",
  null
  
)

export default component.exports